import React from "react";
import "../App.css";
import { NavigationContext } from "../NavigationContext";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  ValidationModule,
  RowSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  PaginationModule,
} from "ag-grid-community";
import Glyphicon from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { getFrequency, deliveryDetailsDate } from "../utils/Helper";
import { ADMIN_TYPE } from "../utils/Constants";
import $ from "jquery";

class ReportAGgrid extends React.Component {
  static contextType = NavigationContext;
  constructor(props) {
    super(props);
    this.adminType = localStorage.getItem("role");
    this.state = {
      show: false,
      ScheduleList: [],
      pageSize: 10,

      columnDefs: [
        {
          headerName: "Schedule Name",
          field: "reportName",
          width: 280,
          cellRenderer: (params) => {
            return (
              <Button
                className="schoolLink"
                style={{ backgroundColor: "transparent", border: "none" }}
                onClick={() => this.props.onShowHistory(params)}
              >
                {params.data[this.state.columnDefs[0].field]}
              </Button>
            );
          },
        },
        {
          headerName: "Report Name",
          field: "type",
          cellRenderer: (params) => this.getName(params),
        },
        {
          headerName: "Frequency",
          field: "frequency",
          width: 150,
          cellRenderer: (params) => getFrequency(params.value),
        },
        {
          headerName: "Delivery Details",
          field: "lastUpdatedDate",
          cellRenderer: (params) => deliveryDetailsDate(params.value),
        },
        {
          headerName: "Delivery Status",
          field: "reportExecutionStatus",
        },
        {
          headerName: "",
          field: "delete",
          colId: "view",
          pinned: "right",
          width: 100,
          cellRenderer: (params) => {
            return (
              <Button
                className="delete_button_schedule"
                style={{ backgroundColor: "transparent", border: "none" }}
                onClick={() => this.props.onDelete(params)}
                disabled={
                  this.adminType === ADMIN_TYPE.SALESADMIN ||
                  this.adminType === ADMIN_TYPE.SCHOOLADMIN
                }
              ></Button>
            );
          },
        },
      ],
      paginationPageSize: 10,
      rowData: [
        {
          schoolId: "string",
          sheduleName: "string",
          reportName: "string",
          frequency: "string",
          deliveryDetails: "string",
          deliveryStatus: "string",
        },
      ],
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
    this.testCellRenderer = this.testCellRenderer.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }
  handleShow = (params) => {
    localStorage.setItem("globalMerchantId", params.data.merchantId);
    localStorage.setItem("superAdminSchoolName", params.data.name);
    localStorage.setItem("icon", params.data.icon);
    localStorage.setItem("schoolDataProvided", params.data.schoolDataProvided);
    this.context.navigateTo("/skiply-portal/LandingPage");
  };
  getName = (params) => {
    if (params.data.reportCategory === "CUSTOM") {
      return params.data.customTemplateName;
    } else {
      return params.data.type;
    }
  };
  testCellRenderer() {
    let g =
      '<button class="glyphicon glyphicon-edit" onclick=' +
      this.editApp() +
      ">Edit</button>";
    return g;
  }

  // *****************************************************************************
  // *****************************************************************************
  // *****************************************************************************
  // Render Methods...

  render() {
    let StudentIdInUpdate = this.state.ScheduleList.map((object, index) => (
      <p key={index}>{object.studentId}</p>
    ));
    return (
      <div
        style={{
          height: 575,
          marginLeft: 10,
          marginRight: 10,
          overflowX: "auto",
        }}
      >
        <AgGridReact
          modules={[
            ClientSideRowModelModule,
            ValidationModule,
            RowSelectionModule,
            TextFilterModule,
            NumberFilterModule,
            DateFilterModule,
            CustomFilterModule,
            PaginationModule,
          ]}
          columnDefs={this.state.columnDefs}
          overlayLoadingTemplate={this.state.overlayLoadingTemplate}
          rowData={this.props.studentDetails}
        ></AgGridReact>
      </div>
    );
  }
}

export default ReportAGgrid;
